var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-alert', {
    attrs: {
      "variant": "warning",
      "show": _vm.showEmptyResultsAlert
    }
  }, [_vm._v(" No search results turned up. ")]), _c('b-input-group', {
    staticClass: "d-flex"
  }, [_c('b-input-group-prepend', [_c('b-input-group-text', [_c('b-icon-search', {
    staticClass: "tw-text-eclipse"
  })], 1)], 1), _c('b-form-input', {
    ref: "searchInput",
    staticClass: "grow-1 tw-p-0",
    attrs: {
      "placeholder": "Search...",
      "type": "search",
      "autocomplete": "off"
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _vm.search.length > 0 ? _c('b-input-group-prepend', {
    staticClass: "p-0"
  }, [_c('b-input-group-text', {
    staticClass: "p-0"
  }, [_c('b-button', {
    staticClass: "border-0 align-self-center p-0",
    attrs: {
      "variant": "outline-white"
    },
    on: {
      "click": _vm.clearSearch
    }
  }, [_c('b-icon-x-circle', {
    staticClass: "tw-text-eclipse"
  })], 1)], 1)], 1) : _vm._e()], 1), _c('b-table', {
    ref: "table",
    staticClass: "card-table",
    style: _vm.tableStyle,
    attrs: {
      "no-border-collapse": "",
      "responsive": "",
      "select-mode": "single",
      "fields": _vm.headers,
      "items": _vm.items,
      "sticky-header": "",
      "show-empty": ""
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function (data) {
        return [_vm.fetchingReports ? _c('p', {
          staticClass: "tw-text-center"
        }, [_vm._v(" Fetching doctors... ")]) : _c('p', {
          staticClass: "tw-text-center"
        }, [_vm._v(" " + _vm._s(data.emptyText) + " ")])];
      }
    }, {
      key: "cell(photo)",
      fn: function (row) {
        return [_c('b-avatar', {
          attrs: {
            "size": "md",
            "src": row.item.avatar_url
          }
        })];
      }
    }, {
      key: "cell(name)",
      fn: function (row) {
        return [_c('span', {
          staticClass: "tw-text-secondary-light"
        }, [_vm._v(" Dr. " + _vm._s(row.item.firstname) + " " + _vm._s(row.item.lastname) + " ")])];
      }
    }, {
      key: "cell(averagetotaldelinquent)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(row.item.averagetotaldelinquent) + " ")];
      }
    }, {
      key: "cell(averagemessages)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(row.item.averagemessages) + " ")];
      }
    }, {
      key: "cell(averagefollowups)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(row.item.averagefollowups) + " ")];
      }
    }, {
      key: "cell(oldestpendingtask)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(row.item.oldestpendingtask) + " ")];
      }
    }, {
      key: "cell(actions)",
      fn: function (row) {
        return [_c('b-button', {
          staticClass: "!tw-secondary",
          attrs: {
            "disabled": _vm.fetchingUpdate[row.item.report_id],
            "size": "sm"
          },
          on: {
            "click": function ($event) {
              return _vm.refreshReport(row.item.report_id);
            }
          }
        }, [_c('b-icon', {
          staticClass: "mr-2",
          attrs: {
            "icon": "arrow-clockwise"
          }
        }), _vm._v(" " + _vm._s(_vm.fetchingUpdate[row.item.report_id] ? 'Refreshing...' : 'Refresh Data') + " ")], 1)];
      }
    }])
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };